/* eslint-disable jsx-a11y/anchor-is-valid */
import withValidarRecuperar from 'HOC/withValidarRecuperar';
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import BreadcrumcomponentLogo from 'components/BreadCrumbMex/BreadCrumb';
import BreadCrumbPasosV2 from 'components/BreadCrumbMex/BreadCrumbPasosV2';
import { SimpleCheckBox } from 'components/InputsMex/SimpleInputs';
import { ControllerRender } from 'components/InputsMex/inputs';
import Page from 'components/Page';
import { ambienteAplicacion } from 'constants/urls';
import { URLS_PHP_7 } from 'constants/urls_v2';
import { useNavbarContext } from 'contexts/NavbarContext';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import * as uuid from 'uuid';
import Loading from 'wrappers/Loading';
import EditableTable from '../../components/Table/EditableTable';
import CoberturasAcordeon from './componentes/acordeon';
import CotizacionFooterBarButtons from './componentes/cotizacionFooterBar';
import { validarEquipo, validarSuma } from './componentes/validaciones';
import { MarineInland } from './constantes/general';
import './styles.scss';

const API = ApiKeyFetch.instance();

const MarineInlandMaquinaria = ({
  history,
  addWarningToast,
  addSuccessToast,
  params: { idCotizacion },
  dataUsuario,
  qParams: { back },
  estadoGeneral,
}) => {
  const [loading, setLoading] = useState(false);

  const { cliCodigoCore, userIsLoggedIn, correo } = dataUsuario;
  const [catalogo, setCatalogo] = useState({});

  useNavbarContext(MarineInland.codProducto);

  const methods = useForm({ mode: 'onChange' });
  const { handleSubmit, reset } = methods;

  const solicitarCatalogosGeneral = async () => {
    setLoading(true);
    const solicitudCatalogos = {
      datosCotizador: {
        prodCodigo: MarineInland.codProducto,
        ambiente: ambienteAplicacion,
        pasoCodigo: 'catalogosMaquinaria',
        idCotizacion: idCotizacion,
        usuCotiza: {
          usuCodigo: cliCodigoCore || '',
        },
      },
    };
    let resp = await API.post(URLS_PHP_7.cotizacion.catalogosCotizador, solicitudCatalogos);
    setCatalogo(resp?.catalogo?.catalogos);
    if (back && back != undefined) {
      await getData();
    }
    setLoading(false);
    return true;
  };

  const getData = async () => {
    setLoading(true);
    const DataResumen = {
      cotDatos: {
        ambiente: ambienteAplicacion,
        cotCodigo: idCotizacion,
      },
    };
    let resp = await API.post(URLS_PHP_7.cotizacion.resumenCotizacion, DataResumen);
    if (resp?.transaccion) {
      if (resp?.cotConsulta?.prodDatos?.[0]) {
        const datos = resp?.cotConsulta?.prodDatos?.[0];
        reset({
          datosMaquinaria: datos?.datosMaquinaria,
          baseValuacionValorConvenido: datos?.baseValuacionValorConvenido,
          equipoConGps: datos?.equipoConGps,
          coberturasAdicionales: datos?.coberturasAdicionales,
          seleccionarTodasAdicionales: datos?.seleccionarTodasAdicionales,
        });
      } else {
        reset({
          ...methods.watch(),
          datosMaquinaria: dataTable,
        });
      }
    } else {
      addWarningToast('No se ha podido cargar la información de la cotización');
    }
    setLoading(false);
  };

  useEffect(() => {
    solicitarCatalogosGeneral();
    if (back == undefined) {
      reset({
        ...methods.watch(),
        datosMaquinaria: dataTable,
      });
    }
  }, [idCotizacion]);

  const onSubmit = async (data) => {
    let dataSend = await onRemoverSkipValidation(data);
    if (data?.datosMaquinaria.length > 0) {
      if (dataSend) {
        if (estadoGeneral?.polizaPagada?.validacion) {
          onRedireccionar(idCotizacion);
        } else {
          guardarDataMiddleware(data, 'submit');
        }
      } else {
        onSubmitError();
      }
    } else {
      addWarningToast('Debe ingresar al menos un equipo para continuar');
    }
  };
  const onGuardar = () => {
    let data = methods.watch();
    if (estadoGeneral?.polizaPagada?.validacion) {
      addWarningToast(estadoGeneral?.polizaPagada?.msgError);
    } else {
      guardarDataMiddleware(data, 'save');
    }
  };

  const guardarDataMiddleware = async (data, from) => {
    setLoading(true);
    const Data = {
      ambiente: ambienteAplicacion,
      prodCodigo: MarineInland.codProducto,
      pasoCodigo: 'guardarMaquinaria',
      items: {
        idCotizacion: idCotizacion || '',
        from: from,
        datosMaquinariaCoberturas: data,
        usuCotiza: { usuCodigo: cliCodigoCore || '' },
        agente: data.agente,
      },
    };
    console.log('DAT', JSON.stringify(Data));
    const res = await API.post(URLS_PHP_7.cotizacion.actualizarCotizacion, Data);
    if (res?.transaccion === true && res?.id) {
      if (from != 'submit') {
        onSuccessMsg('Se ha guardado correctamente la información ingresada');
        reset({ ...data });
      } else {
        onRedireccionar(idCotizacion);
      }
    } else {
      reset({ ...data });
      try {
        res.errorDescripcion.forEach((msg) => addWarningToast(msg, { autoDismiss: false }));
      } catch (e) {
        addWarningToast(res?.errorDescripcion || 'Error desconocido', {
          autoDismiss: false,
        });
      }
    }
    setLoading(false);
  };

  const onRedireccionar = (id) => {
    history.replace(`${MarineInland.urls.ingresoEquipos}/${id}`);
    history.push(`${MarineInland.urls.opcionPago}/${id}`);
  };

  const onSuccessMsg = (msg) => {
    addSuccessToast(msg);
  };
  const onSubmitError = () => {
    addWarningToast('Rellene el formulario correctamente');
  };

  const onValidateTableData = (data) => {
    return data?.map((item) => ({
      ...item,
      ...validarEquipo(item),
      ...validarSuma(item, catalogo?.textosValidaciones?.validacionSumaAsegurada),
    }));
  };
  const onClickAtras = () => {
    history.push(`${MarineInland.urls.datosLead}/${idCotizacion}`);
  };
  const onRemoverSkipValidation = async (data) => {
    const newRows = data?.datosMaquinaria?.map((item) => ({
      ...item,
      equipo: {
        ...item.equipo,
        skipValidation: false,
      },
      suma: {
        ...item.suma,
        skipValidation: false,
      },
    }));
    reset({
      ...methods.watch(),
      datosMaquinaria: newRows,
    });
    let result = await methods.trigger();
    return result;
  };
  const onSelectAllCoberturas = (accion) => {
    let arrayAdicionales = methods.watch('coberturasAdicionales', []);
    console.log(arrayAdicionales);
    Object.keys(arrayAdicionales).forEach((key) => {
      arrayAdicionales[key] = accion == 'activar' ? true : false;
    });
    reset({
      ...methods.watch(),
      coberturasAdicionales: arrayAdicionales,
    });
  };
  return (
    <Loading loading={loading}>
      <div className="cr-content">
        <Page>
          <BreadcrumcomponentLogo {...PASOS_BREADCRUMBS[MarineInland.codProducto].breadCrumb} />
          <BreadCrumbPasosV2 {...PASOS_BREADCRUMBS[MarineInland.codProducto].breadCrumbPasos[(1, 2)]} />
          <FormProvider {...methods}>
            <div className="d-flex justify-content-center">
              <div className="col-12 col-xl-10">
                {/* <SimpleErrorMessage name={'datosMaquinaria'} />                */}
                <ControllerRender
                  name="datosMaquinaria"
                  defaultValue={[]}
                  rules={{
                    validate: (/**@type {any[]}*/ value) => {
                      onValidateTableData(value);
                      const hasError = value.some((item) => item.equipo?.hasError || item?.suma?.hasError);
                      if (hasError) {
                        return 'Existen errores en la información ingresada para la maquinaria.';
                      }
                      return true;
                    },
                  }}
                  render={({ onChange, value }) => {
                    return (
                      <EditableTable
                        wsOptions={catalogo?.listadoEquipos}
                        rows={onValidateTableData(value)}
                        setRows={onChange}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <div className="col-12 col-xl-10">
                <div className="col-6 px-4">
                  <SimpleCheckBox
                    name={'baseValuacionValorConvenido'}
                    id={'baseValuacionValorConvenido'}
                    label={'Base de valuación a valor convenido'}
                    type={'slide'}
                    labelClass={'cl-label-slide'}
                    info={catalogo?.textosValidaciones?.textBaseValuacion}
                  />
                  <SimpleCheckBox
                    name={'equipoConGps'}
                    id={'equipoConGps'}
                    label={'Equipo(s) cuenta(n) con GPS'}
                    type={'slide'}
                    labelClass={'cl-label-slide'}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center py-4">
              <div className="col-12 col-xl-10 title-cob-marine">Coberturas</div>
            </div>
            <div className="d-flex justify-content-center">
              <div className="col-12 col-xl-10 table-background">
                <CoberturasAcordeon
                  detail={true}
                  title={catalogo?.coberturasBasicas?.label}
                  dataCoberturas={catalogo?.coberturasBasicas?.coberturas}
                />
                <CoberturasAcordeon
                  title={catalogo?.coberturasAdicionales?.label}
                  dataCoberturas={catalogo?.coberturasAdicionales?.coberturas}
                  onSelectAllCoberturas={onSelectAllCoberturas}
                />
              </div>
            </div>
          </FormProvider>
          <div className="py-4">
            <CotizacionFooterBarButtons
              onClickAtras={onClickAtras}
              onClickGuardar={onGuardar}
              onClickContinuar={methods.handleSubmit(onSubmit, onSubmitError)}
            />
          </div>
        </Page>
      </div>
    </Loading>
  );
};

export default withValidarRecuperar(MarineInlandMaquinaria, MarineInland.codProducto);

const dataTable = [
  {
    uuid: uuid.v4(),
    equipo: {
      value: null,
      hasError: false,
      errorMessage: '',
      skipValidation: true,
    },
    suma: {
      value: null,
      hasError: false,
      skipValidation: true,
    },
  },
];
